import room from '@/api/room'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  found_data: {},
  buildings: [],
  room_types: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FOUND_DATA(state, data) {
    state.found_data = data
  },
  SET_BUILDINGS(state, data) {
    state.buildings = data
  },
  SET_ROOM_TYPES(state, data) {
    state.room_types = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return room.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return room.store(data)
  },

  update(context, data) {
    return room.update(data)
  },

  destroy(context, id) {
    return room.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.found_data)) {
      let response = await room.find(id)
      context.commit('SET_FOUND_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.buildings.length > 0) {
      let response = await room.roomBuilding()
      context.commit('SET_BUILDINGS', response)
    }
    if (!context.state.room_types.length > 0) {
      let response = await room.roomRoomType()
      context.commit('SET_ROOM_TYPES', response)
    }
  }
}
